import React, { useState } from "react";
import {
    Flex,
    Box,
    Text,
    useToast,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import { Auth } from 'aws-amplify';
import { useParams, useNavigate } from "react-router";
import { ConfirmSignUp } from "../../components/ConfirmSignUp";
import { HelmetComponent } from "../../components/HelmetComponent";

const MotionBox = motion(Box);

export const ConfirmSignupPage = () => {
    const { username } = useParams()
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const toast = useToast();

    const onConfirmSignUp = async (code) => {
        setIsLoading(true);
        try {
            await Auth.confirmSignUp(username, code);
            setIsLoading(false);
            navigate("/");
        } catch (err) {
            setIsLoading(false);
            toast({
                position: "top-right",
                description: err.message,
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
    }

    const resendCode = async () => {
        setIsLoading(true);
        try {
            await Auth.resendSignUp(username).then(data => {
                console.log(data)
            })
            setIsLoading(false);
            toast({
                position: "top-right",
                description: `Verification email resent. Please check your inbox.`,
                status: "success",
                duration: 2000,
                isClosable: true,
            });
        } catch (err) {
            setIsLoading(false);
            toast({
                position: "top-right",
                description: err.message,
                status: "error",
                duration: 2000,
                isClosable: true,
            });
        }
    }

    return (
        <>
            <HelmetComponent title={`SignUp - Edshopify`} />
            <Flex
                sx={{
                    minHeight: "100vh",
                    alignItems: { base: "flex-start", sm: "center" },
                    padding: "20px"
                }}
            >
                <Box sx={{ width: "100%" }}>
                    <Text className='logo' sx={{ margin: "0 0 20px", textAlign: "center" }}>EdShopify</Text>
                    <MotionBox
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        maxW="md"
                        mx="auto"
                        p={{ base: 0, sm: 6 }}
                        borderWidth={{ base: "none", sm: "1" }}
                        borderRadius={{ base: "none", sm: "lg" }}
                        shadow={{ base: "none", sm: "lg" }}
                        sx={{
                            minWidth: { base: "100%", sm: "400px" }
                        }}
                    >
                        <ConfirmSignUp
                            username={username}
                            onConfirmSignUp={onConfirmSignUp}
                            resendCode={resendCode}
                            isLoading={isLoading}
                        />
                    </MotionBox>
                </Box>
            </Flex>
        </>
    );
}